import React from 'react';
import { TextInput, required, SelectInput } from 'react-admin';

import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';

const UserForm = ({ roles }) => (
  <Grid container spacing={3}>
    <Grid item xs={12} sm={12} md={4}>
      <TextInput
        source="email"
        label="Correo electrónico"
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={3}>
      <TextInput
        source="username"
        label="Nombre de usuario"
        fullWidth
        validate={required()}
      />
    </Grid>
    <Grid item xs={12} sm={12} md={2}>
      <SelectInput
        fullWidth
        defaultValue={roles[0].id}
        choices={roles}
        label="Rol"
        source="role"
      />
    </Grid>
    <Grid item xs={12} sm={12} md={3}>
      <TextInput
        type="password"
        source="password"
        label="Contraseña"
        fullWidth
        validate={required()}
      />
    </Grid>
  </Grid>
);

UserForm.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
};

export default UserForm;
